define('WeltPixel_ProductPage/js/mixins/amazon-button-mixin',[
    'ko',
    'jquery',
    'Amazon_Pay/js/action/checkout-session-config-load',
    'Amazon_Pay/js/model/storage',
    'mage/url',
    'Amazon_Pay/js/amazon-checkout',
    'Magento_Customer/js/customer-data',
    'Magento_Checkout/js/model/payment/additional-validators',
    'mage/storage',
    'Magento_Checkout/js/model/error-processor'
], function (
    ko,
    $,
    checkoutSessionConfigLoad,
    amazonStorage,
    url,
    amazonCheckout,
    customerData,
    additionalValidators,
    storage,
    errorProcessor
) {
    'use strict';

    return function (widget) {
        $.widget('amazon.AmazonButton', widget, {
            /**
             * Draw button
             **/
            _draw: function () {
                var self = this;

                if (!this.drawing) {

                    this.drawing = true;
                    var $buttonContainer = this.element;
                    amazonCheckout.withAmazonCheckout(function (amazon, args) {
                        var $buttonRoot = $('<div></div>');
                        $buttonRoot.html('<img src="' + require.toUrl('images/loader-1.gif') + '" alt="" width="24" />');
                        $buttonContainer.empty().append($buttonRoot);

                        this._loadButtonConfig(function (buttonConfig) {
                            // do not use session config for decoupled button
                            delete buttonConfig.createCheckoutSessionConfig;
                            var amazonPayButton = amazon.Pay.renderButton('#' + $buttonRoot.empty().removeUniqueId().uniqueId().attr('id'), buttonConfig);

                            var style = document.createElement( 'style' )
                            style.innerHTML = '.amazonpay-button-view3 { display: none; } ' +
                                '.amazonpay-button-container { max-width: 130px; }' +
                                '.amazon-checkout-now { display: none; }'

                            if (document.getElementById('PayWithAmazon-Product')) {
                                document.getElementById('PayWithAmazon-Product')
                                    .children[0].shadowRoot.appendChild(style);
                            }

                            amazonPayButton.onClick(function() {
                                if (self.buttonType === 'PayNow' && !additionalValidators.validate()) {
                                    return false;
                                }
                                //This is for compatibility with Iosc. We need to update the customer's Magento session before getting the final config and payload
                                if (self.buttonType === 'PayNow' && self.options.isIosc()) {
                                    storage.post(
                                        'checkout/onepage/update',
                                        "{}",
                                        false
                                    ).done(
                                        function (response) {
                                            if (!response.error) {
                                                self._initCheckout(amazonPayButton);
                                            } else {
                                                errorProcessor.process(response);
                                            }
                                        }
                                    ).fail(
                                        function (response) {
                                            errorProcessor.process(response);
                                        }
                                    );
                                }else{
                                    self._initCheckout(amazonPayButton);
                                }
                            });

                            $('.amazon-button-container .field-tooltip').fadeIn();
                            self.drawing = false;
                        });
                    }, this);
                }
            },
        });

        return $.amazon.AmazonButton;
    }
});

